// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Llogo from '../img/Llogo.png';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeftOutlined } from '@ant-design/icons';

// const dist = sessionStorage.getItem("dist");

// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflow: 'hidden',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
//   fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   color: 'rgb(14, 57, 114)',
// };

// const headerStyle = {
//   height: '100px',
//   backgroundColor: '#fff',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   fontSize: '20px',
//   fontWeight: 'bold',
//   borderBottom: '1px solid #ddd',
// };

// const scrollViewStyle = {
//   padding: '10px 15px',
//   overflowY: 'auto',
//   flex: 1,
// };

// const cardStyle = {
//   backgroundColor: '#fff',
//   marginBottom: '20px',
//   padding: '15px',
//   borderRadius: '8px',
//   boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
// };

// const imageStyle = {
//   display: 'block',
//   height: '100px',
//   width: '100px',
//   margin: '0 auto 10px',
// };

// const contentStyle = {
//   backgroundColor: 'rgb(217, 221, 224)',
//   borderRadius: '4px',
//   padding: '10px',
//   fontSize: '16px',
//   color: 'black',
// };

// const DGDiaryWeb = () => {
  // const [diaryData, setDiaryData] = useState([]);
  //   const navigate = useNavigate();

  // const fetchDiaryData = async () => {
  //   try {
  //     const response = await axios.get('https://lionsdirectoryapi.emedha.in/DGDiary/api/diary/get', {
  //       params: { dist },
  //     });
  //     setDiaryData(response.data);

  //   } catch (error) {
  //     console.error('Error fetching diary data:', error);
  //   }
  // };


  // useEffect(() => {
  //   fetchDiaryData();
  // }, []);

//   return (
//     <div style={previewContainerStyle}>
//         <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>DG Diary</h6>
//       </div>
//     </div>
//       <div style={scrollViewStyle}>
//         {diaryData.map((entry) => (
//           <div key={entry.id} style={cardStyle}>
//             <img src={Llogo} alt="Logo" style={imageStyle} />
//             <div style={contentStyle}>
//               <div><strong>Program:</strong> {entry.program}</div>
//               <div><strong>Start Date:</strong> {entry.startDate}</div>
//               <div><strong>End Date:</strong> {entry.endDate}</div>
//               <div><strong>Description:</strong> {entry.description}</div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default DGDiaryWeb;

import React, { useEffect, useState } from 'react';
import { ChevronLeft, BookOpen, Calendar, ClipboardList } from 'lucide-react';
import axios from 'axios';

const DGDiaryWeb = ({ onBack, styles }) => {
  // Data structure focused on Program Name, Start/End Dates, and Description

    const [diaryData, setDiaryData] = useState([]);
 
  const dist = sessionStorage.getItem("dist");

  const fetchDiaryData = async () => {
    try {
      const response = await axios.get('https://lionsdirectoryapi.emedha.in/DGDiary/api/diary/get', {
        params: { dist },
      });
      setDiaryData(response.data);

    } catch (error) {
      console.error('Error fetching diary data:', error);
    }
  };


  useEffect(() => {
    fetchDiaryData();
  }, []);


  return (
    <div style={styles.scrollArea}>
      {/* Navigation Header */}
      <div 
        onClick={onBack} 
        style={{ padding: '15px 15px 5px', display: 'flex', alignItems: 'center', color: '#0033A0', cursor: 'pointer' }}
      >
        <ChevronLeft size={20} />
        <span style={{ fontSize: '14px', fontWeight: '600' }}>Back to Home</span>
      </div>

      {/* Page Title Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 15px 10px' }}>
        <div style={{ 
          backgroundColor: '#FFC20E', color: 'white', width: '45px', height: '45px', 
          borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' 
        }}>
          <BookOpen size={24} />
        </div>
        <h1 style={{ fontSize: '24px', color: '#0033A0', margin: 0 }}>DG Diary</h1>
      </div>

      <div style={{ padding: '0 15px 20px', fontSize: '13px', color: '#666', lineHeight: '1.4' }}>
        District Governor's Journal - Updates and reflections on district activities
      </div>

      {/* Diary Entry Cards */}
      <div style={{ padding: '0 15px' }}>
        {diaryData.map((entry, index) => (
          <div key={index} style={{
            backgroundColor: 'white', borderRadius: '12px', padding: '18px',
            marginBottom: '16px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
          }}>
            {/* Date Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#0033A0', marginBottom: '10px' }}>
              <Calendar size={16} />
              <span style={{ fontSize: '12px', fontWeight: '600' }}>
                {entry.startDate} {entry.startDate !== entry.endDate && ` - ${entry.endDate}`}
              </span>
            </div>

            {/* Program Name */}
            <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#000', fontWeight: 'bold' }}>
              {entry.program}
            </h3>

            {/* Description */}
            <p style={{ 
              margin: '0 0 15px 0', fontSize: '14px', color: '#555', 
              lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: '3', 
              WebkitBoxOrient: 'vertical', overflow: 'hidden' 
            }}>
              {entry.description}
            </p>

            {/* Action Link */}
            {/* <div style={{ 
              display: 'flex', alignItems: 'center', color: '#0033A0', 
              fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' 
            }}>
              Read More <span style={{ marginLeft: '5px' }}>→</span>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DGDiaryWeb;
